// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-pagination .ngx-pagination .current {
  background: red;
}

.my-pagination ul {
  padding-left: 0em;
}

.provider-list {
  display: flex;
  flex-wrap: wrap;
}
.provider-list .button-wrapper {
  flex: 1 0 50%;
  padding: 0 3px;
}
.provider-list .button-wrapper button {
  width: 100%;
}

.ogsDetails .alert-message {
  max-height: none;
  overflow: auto;
}

.button-col {
  display: grid;
}

ion-popover {
  --width: auto;
}

ion-item {
  --padding-start: 0px;
  border: 1px solid black;
}

ion-datetime {
  max-width: 100%;
}

::ng-deep .igtDetails .alert-message {
  overflow-y: auto !important;
}
::ng-deep .igtDetails .alert-md .alert-message {
  max-height: 50% !important;
  height: 50% !important;
}
::ng-deep .igtDetails .alert-wrapper {
  width: 50%;
  max-width: 50%;
}
::ng-deep .ogsDetails table {
  width: 100%;
}
::ng-deep .ogsDetails table tr .gd-game {
  width: 50%;
}
::ng-deep .ogsDetails table tr .gd-status {
  width: 50%;
}
::ng-deep .ogsDetails table tr .gd-aid {
  width: 50%;
}
::ng-deep .ogsDetails .alert-header {
  font-weight: bold;
}
::ng-deep .ogsDetails .alert-message {
  overflow-y: auto !important;
}
::ng-deep .ogsDetails .alert-md .alert-message {
  max-height: 50% !important;
  height: 50% !important;
}
::ng-deep .ogsDetails .alert-wrapper {
  width: 50%;
  max-width: 50%;
}

.comment-text {
  margin-bottom: 1px;
}

@media only screen and (max-width: 600px) {
  ::ng-deep .igtDetails .alert-wrapper {
    width: 100%;
    max-width: 100%;
  }
  ::ng-deep .ogsDetails .alert-wrapper {
    width: 100%;
    max-width: 100%;
  }
}
@media only screen and (max-width: 786px) {
  ::ng-deep .igtDetails ::-webkit-scrollbar-track, ::ng-deep .ogsDetails ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
    border-radius: 3px !important;
    background-color: #fff;
  }
  ::ng-deep .igtDetails ::-webkit-scrollbar, ::ng-deep .ogsDetails ::-webkit-scrollbar {
    width: 5px !important;
    height: 5px;
    background-color: #fff;
  }
  ::ng-deep .igtDetails ::-webkit-scrollbar-thumb, ::ng-deep .ogsDetails ::-webkit-scrollbar-thumb {
    border-radius: 3px !important;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;
    background-color: #aaa !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/game-history/game-history.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,eAAA;AACJ;AACI;EACI,aAAA;EACA,cAAA;AACR;AACQ;EACI,WAAA;AACZ;;AAKI;EAEI,gBAAA;EACA,cAAA;AAHR;;AAOA;EACI,aAAA;AAJJ;;AAOA;EACI,aAAA;AAJJ;;AAOA;EACI,oBAAA;EACA,uBAAA;AAJJ;;AAQA;EACI,eAAA;AALJ;;AAUQ;EACI,2BAAA;AAPZ;AAUQ;EACI,0BAAA;EACA,sBAAA;AARZ;AAWQ;EACI,UAAA;EACA,cAAA;AATZ;AAcQ;EACI,WAAA;AAZZ;AAegB;EACI,UAAA;AAbpB;AAgBgB;EACI,UAAA;AAdpB;AAiBgB;EACI,UAAA;AAfpB;AAsBQ;EACI,iBAAA;AApBZ;AAuBQ;EACI,2BAAA;AArBZ;AAwBQ;EACI,0BAAA;EACA,sBAAA;AAtBZ;AAyBQ;EACI,UAAA;EACA,cAAA;AAvBZ;;AA4BA;EACI,kBAAA;AAzBJ;;AA6BI;EAEQ;IACI,WAAA;IACA,eAAA;EA3Bd;EA+BU;IACI,WAAA;IACA,eAAA;EA7Bd;AACF;AAgCI;EAGQ;IACI,+DAAA;IACA,6BAAA;IACA,sBAAA;EAhCd;EAmCU;IACI,qBAAA;IACA,WAAA;IACA,sBAAA;EAjCd;EAoCU;IACI,6BAAA;IACA,+DAAA;IACA,iCAAA;EAlCd;AACF","sourcesContent":[".my-pagination .ngx-pagination .current {\r\n    background: red;\r\n}\r\n\r\n.my-pagination ul {\r\n    padding-left: 0em;\r\n}\r\n\r\n.provider-list {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n\r\n    .button-wrapper {\r\n        flex: 1 0 50%;\r\n        padding: 0 3px;\r\n\r\n        button {\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n.ogsDetails {\r\n    .alert-message {\r\n        // color: $main-dark-color;\r\n        max-height: none;\r\n        overflow: auto;\r\n    }\r\n}\r\n\r\n.button-col {\r\n    display: grid;\r\n}\r\n\r\nion-popover {\r\n    --width: auto;\r\n}\r\n\r\nion-item {\r\n    --padding-start: 0px;\r\n    border: 1px solid black;\r\n\r\n}\r\n\r\nion-datetime {\r\n    max-width: 100%;\r\n}\r\n\r\n::ng-deep {\r\n    .igtDetails {\r\n        .alert-message {\r\n            overflow-y: auto !important;\r\n        }\r\n\r\n        .alert-md .alert-message {\r\n            max-height: 50% !important;\r\n            height: 50% !important;\r\n        }\r\n\r\n        .alert-wrapper {\r\n            width: 50%;\r\n            max-width: 50%;\r\n        }\r\n    }\r\n\r\n    .ogsDetails {\r\n        table {\r\n            width: 100%;\r\n\r\n            tr {\r\n                .gd-game {\r\n                    width: 50%\r\n                }\r\n\r\n                .gd-status {\r\n                    width: 50%\r\n                }\r\n\r\n                .gd-aid {\r\n                    width: 50%\r\n                }\r\n            }\r\n\r\n\r\n        }\r\n\r\n        .alert-header {\r\n            font-weight: bold;\r\n        }\r\n\r\n        .alert-message {\r\n            overflow-y: auto !important;\r\n        }\r\n\r\n        .alert-md .alert-message {\r\n            max-height: 50% !important;\r\n            height: 50% !important;\r\n        }\r\n\r\n        .alert-wrapper {\r\n            width: 50%;\r\n            max-width: 50%;\r\n        }\r\n    }\r\n}\r\n\r\n.comment-text {\r\n    margin-bottom: 1px;\r\n}\r\n\r\n::ng-deep {\r\n    @media only screen and (max-width: 600px) {\r\n        .igtDetails {      \r\n            .alert-wrapper {\r\n                width: 100%;\r\n                max-width: 100%;\r\n            }\r\n        }\r\n        .ogsDetails {\r\n            .alert-wrapper {\r\n                width: 100%;\r\n                max-width: 100%;\r\n            }\r\n        }\r\n    }\r\n    @media only screen and (max-width: 786px) {\r\n        .igtDetails, .ogsDetails {      \r\n            //Scroll BAR\r\n            ::-webkit-scrollbar-track {\r\n                -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;\r\n                border-radius: 3px !important;\r\n                background-color: #fff;\r\n            }\r\n\r\n            ::-webkit-scrollbar {\r\n                width: 5px !important;\r\n                height: 5px;\r\n                background-color: #fff;\r\n            }\r\n\r\n            ::-webkit-scrollbar-thumb {\r\n                border-radius: 3px !important;\r\n                -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3) !important;\r\n                background-color: #aaa !important;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
